<template>
  <div class="student">
    <div class="top-banner">
      学 生 风 采
    </div>
    <!-- 学历提升政策 -->
    <div
      class="student-policy"
      :class="i % 2 ? 'bg' : ''"
      v-for="(item, i) in studentList"
      :key="item.id"
    >
      <div class="g-box">
        <div class="top-title">{{ item.title }}</div>
        <div class="sub-title">{{ item.subtitle }}</div>
        <div class="content">
          <div class="le">
            <img class="img" :src="item.content[0]" alt="" />
          </div>
          <div class="mid">
            <div class="top">
              <img :src="item.content[1]" alt="" class="img" />
            </div>
            <div class="bot">
              <div class="item">
                <img :src="item.content[2]" alt="" class="img" />
              </div>
              <div class="item">
                <img :src="item.content[3]" alt="" class="img" />
              </div>
            </div>
          </div>
          <div class="ri">
            <img :src="item.content[4]" alt="" class="img" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";
export default {
  mixins: [pageMain_mx],
  data() {
    return {
      studentList: []
    };
  },
  components: {},
  async mounted() {
    // 优秀班主任
    const menuId = this.getMenuId("活动展示");
    if (menuId) {
      const data = await this.getMenuList({
        pageNum: 1,
        pageSize: 1000,
        menuId: menuId
      });
      data.forEach(item => {
        item.content = item.content.split(",");
      });
      this.studentList = data;
      console.log(data, "data");
    }
  },
  methods: {}
};
</script>
<style lang="less">
.student {
  .top-banner {
    padding-top: 80px;
    text-align: center;
    height: 280px;
    background: url("../../assets/img/student-bg.png") no-repeat center top;
    background-size: cover;
    box-sizing: border-box;
    font-size: 60px;
    color: #fff;
    line-height: 84px;
    letter-spacing: 8px;
  }
  //  学历提升政策
  &-policy {
    padding: 60px 0;
    .top-title {
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      color: #202930;
      letter-spacing: 4px;
    }
    .sub-title {
      margin-top: 10px;
      text-align: center;
      font-size: 16px;
      color: #656878;
    }
    .content {
      margin-top: 60px;
      display: flex;
      .le {
        margin-right: 10px;
        width: 460px;
        height: 340px;
        .img {
          width: 460px;
          height: 340px;
        }
      }
      .mid {
        margin-right: 10px;
        .top {
          margin-bottom: 10px;
          width: 460px;
          height: 170px;
          .img {
            width: 460px;
            height: 170px;
          }
        }
        .bot {
          display: flex;
          .item {
            margin-right: 10px;
            width: 225px;
            height: 160px;
            .img {
              width: 225px;
              height: 160px;
            }
          }
          .item:nth-child(2n) {
            margin-right: 0;
          }
        }
      }
      .ri {
        width: 260px;
        height: 340px;
        .img {
          width: 260px;
          height: 340px;
        }
      }
    }
  }
  &-policy.bg {
    background-color: #3767d1;
    .top-title {
      color: #fff;
    }
    .sub-title {
      color: #fff;
    }
  }
}
</style>
